import generateId from 'lib/generateId';
import * as constants from 'app/modules/user/constants';

import { AUTHENTICATION_SUCCESS } from 'app/modules/app/constants';

const { USER_CREATE, USER_CREATE_SUCCESS } = constants;

/*
 * Reducers
 */

export default (state = {}, action) => {
  switch (action.type) {
    case USER_CREATE:
    case USER_CREATE_SUCCESS:
    case AUTHENTICATION_SUCCESS:
      return {
        ...state,
        ...action.record,
      };
    default:
      return state;
  }
};

/*
 * Action creators
 */

export const createOnboardingUser = ({ name, email }) => {
  const id = generateId();
  const hasOnboarded = true;
  return { type: USER_CREATE, record: { id, name, email, hasOnboarded } };
};

export const createEmptyUser = () => {
  const id = generateId();
  const gladlyCustomerId = generateId();
  return { type: USER_CREATE, record: { id, gladlyCustomerId } };
};
export const createUserSuccess = ({ id, name, email }) => ({
  type: USER_CREATE_SUCCESS,
  record: { name, email, id },
});
